/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_EntriesInputs */

const es_chat_tool_detail_entries = /** @type {(inputs: Chat_Tool_Detail_EntriesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} elementos`)
};

const en_chat_tool_detail_entries = /** @type {(inputs: Chat_Tool_Detail_EntriesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} entries`)
};

/**
* | output |
* | --- |
* | "{count} entries" |
*
* @param {Chat_Tool_Detail_EntriesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_entries = /** @type {((inputs: Chat_Tool_Detail_EntriesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_EntriesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_entries(inputs)
	return en_chat_tool_detail_entries(inputs)
});
export { chat_tool_detail_entries as "chat.tool_detail.entries" }